import { MonitoringPhaseHeader } from '@features/monitoringOffer/components/MonitoringPhaseHeader';
import { useAppbarTitle } from '@hooks/useAppbarTitle';
import { usePageTitle } from '@hooks/usePageTitle';
import { useWindowSize } from '@hooks/useWindowSize';
import { mdiArrowLeft } from '@mdi/js';
import Icon from '@mdi/react';
import { Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useMonitoringOffersStore } from 'services/monitoring-offers';
import MonitoringPhaseMainCard from '../components/Card/MonitoringPhaseMainCard';
import MonitoringPhases from '../components/MonitoringPhases';

const styles = {
	container: {
		display: 'flex',
		flexDirection: 'column',
		boxShadow: 3,
		position: 'relative',
		bgcolor: 'white',
		borderRadius: 3,
	},
};

export const MonitoringProtocolPage = () => {
	const { selectedOffer } = useMonitoringOffersStore();

	const { t } = useTranslation();
	const size = useWindowSize();
	const navigate = useNavigate();

	usePageTitle(t('protocols'));
	useAppbarTitle('protocols');

	const offer =
		Object.keys(selectedOffer).length === 0
			? JSON.parse(localStorage.getItem('selectedOffer') || '{}')
			: selectedOffer;

	return (
		<Box
			sx={{
				...styles.container,
				minHeight: size.width > 768 ? '100%' : 'auto',
			}}
		>
			<div className="flex justify-center items-center my-5">
				<div className="absolute left-[20px]">
					<Button
						className="w-[120px]"
						type="submit"
						onClick={() => navigate(-1)}
						variant="text"
						sx={{ color: 'black' }}
						startIcon={<Icon path={mdiArrowLeft} size={1} />}
					>
						<span className="max-xsm:hidden">{t('back')}</span>
					</Button>
				</div>
				<h2 className="md:text-2xl font-bold">{t('phases')}</h2>
			</div>
			<div className="p-0 md:p-5 gap-3 flex flex-col">
				<MonitoringPhaseHeader data={offer} />
				<div className="p-5 md:p-0 gap-3 flex flex-col">
					{offer?.phases_management?.active?.length
						? offer.phases_management.active.map((phase: any, index: any) => (
								<div key={index}>
									<MonitoringPhaseMainCard data={phase} reports={offer.report || []} />
								</div>
							))
						: null}
					<MonitoringPhases phases={offer.phases_management} reports={offer.report || []} />
				</div>
			</div>
		</Box>
	);
};
